import { MailLogPage } from "../../../model/mail/MailLogPage/MailLogPage";

export const FN30S15ProjectMailLog = () => {
  return <MailLogPage type={"project"} />;
};
